import { useNavigate } from 'react-router-dom';
import Button from '../../items/Button';

/**
 * AskQuestionButton component that renders a button for navigating to the
 * "New Question" page. When clicked, it redirects the user to the page
 * where they can ask a new question.
 */
const AskQuestionButton = () => {
  const navigate = useNavigate();

  /**
   * Function to handle navigation to the "New Question" page.
   */
  const handleNewQuestion = () => {
    navigate('/new/question');
  };

  return (
    <Button
      onClick={() => {
        handleNewQuestion();
      }}>
      Ask a Question
    </Button>
  );
};

export default AskQuestionButton;
